export const FilterDomesticFlitght = (flightList, selectedAirlines, minPrice, maxPrice) => {
  const InboundFlights = flightList?.InboundFlights;
  const OutboundFlights = flightList?.OutboundFlights;
  var filterResults = { InboundFlights: [], OutboundFlights: [] };
  var minprice = minPrice;
  var maxprice = maxPrice;
  if (OutboundFlights?.length > 0) {
    OutboundFlights.forEach(flight => {
      if (selectedAirlines.length === 0 || selectedAirlines.findIndex(airline => airline.Code === flight.AirlineCode) >= 0) {
        if (minprice <= flight.TotalFare && flight.TotalFare <= maxprice) {
          filterResults.OutboundFlights.push(flight);
        }
      }
    });
  }
  if (InboundFlights?.length > 0) {
    InboundFlights.forEach(flight => {
      if (selectedAirlines.length === 0 || selectedAirlines.find(airline => airline.Code === flight.AirlineCode)) {
        if (minprice <= flight.TotalFare && flight.TotalFare <= maxprice) {
          filterResults.InboundFlights.push(flight);
        }
      }
    });
  }
  return filterResults;
}